export type LegalSection = {
  id: string;
  num: string;
  title: string;
  rawBlock: string;
};

function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function extractSections(content: string): LegalSection[] {
  const lines = content.split('\n');
  const sections: LegalSection[] = [];
  let current: { title: string; lines: string[] } | null = null;
  let counter = 0;

  const flush = () => {
    if (current) {
      counter += 1;
      const num = String(counter).padStart(2, '0');
      sections.push({
        id: slugify(current.title),
        num,
        title: current.title,
        rawBlock: current.lines.join('\n').trim(),
      });
    }
  };

  for (const line of lines) {
    if (line.startsWith('## ')) {
      flush();
      current = { title: line.slice(3).trim(), lines: [] };
    } else if (current) {
      current.lines.push(line);
    }
  }
  flush();

  return sections;
}
